<template>
  <select-field ref="ETABLISSEMENT_T3252"
                :value=display
                :items=items
                :disabled=readOnly
                :editFieldInfo=editFieldInfo
                :required=required
                :showMissing=showMissing
                :contextId=contextId
                @updated=setUpdated
                @error=setError>
  </select-field>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from "vue";
  import { FieldError, FieldStatus, FieldInfo, EditFieldType, EditFieldTheme } from '@/framework/base/components/FieldInfo'
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';
  import SelectField from '@/framework/base/components/SelectField.vue'
  import Item from '@/framework/base/classes/Item';
  import validator from '@/generated/validators/ValidationRules';

  export default defineComponent({
    components: {
      SelectField
    },

    props: {
      value: {
        type: Number,
        required: true
      },
      contextId: {
        type: Number,
        required: true
      },
      readOnly: {
        type: Boolean,
      },
      required: {
        type: Boolean,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      showMissing: {
        type: Boolean,
      },
    },

    created (): void {
      this.initValue = Item.fromValue(this.items, this.value).key;
      this.status.objId = this.contextId;
    },

    data() {
      const items: Item[] = [
        { "key": 1, "title": "Audio-visuel" },
        { "key": 2, "title": "Spectacle vivant" }
      ];
      return {
        initValue: 0,
        lastContextId: 0,
        status: new FieldStatus(false, false, 0),
        items
      }
    },

    computed: {
      ressource () { return RessourceGenControl(GenControl.ETABLISSEMENT_T3252); },

      editFieldInfo (): FieldInfo {
        const type = EditFieldType.CHOIX;
        const precision = 2;
        const format = null;
        const mask = this.mask;
        const focus = this.focusValidator;
        const live = this.liveValidator;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
      },

      display (): string {
        this.changeContext();
        const item = Item.fromValue(this.items, this.value);
        return item.title;
      }
    },

    methods: {
      changeContext (): void {
        if (this.contextId != this.lastContextId) {
          this.lastContextId = this.contextId;
          this.status.objId = this.contextId;
          this.initValue = this.value ? this.value : 0;
        }
      },

      // eslint-disable-next-line
      focusValidator (value: string): validator | null {
        return  null;
      },

      // eslint-disable-next-line
      liveValidator (value: string): validator | null {
        return null;
      },

      // eslint-disable-next-line
      mask (value: string): string {
        return '';
      },

      save (): void {
        this.initValue = Item.fromValue(this.items, this.value).key;
        this.status.clear(this.contextId);
        this.$emit('status', this.status);
      },

      setUpdated (item: Item): void {
        this.status.updated = item.key != this.initValue;
        this.$emit('update:value', item.key);
        this.$emit('status', this.status);
      },

      setError (value: FieldError): void {
        this.status.error = value.error;
        this.$emit('status', this.status);
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.ETABLISSEMENT_T3252.missing();
      },

      touch (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.ETABLISSEMENT_T3252.touch();
      }
    }
  })
</script>
